import AppColors from "../colors/AppColors";
import React from "react";
import {LoginState} from "../enums/AuthState";
import {useSelector, RootStateOrAny} from "react-redux";
import {Typography, Link} from "@material-ui/core";
import Strings from "../lang/Strings";
import {Constants} from "../constants/Constants";

export function Copyright() {

    const logInState: LoginState = useSelector((state: RootStateOrAny) => state.appReducer[Constants.LOGIN_STATE]);

    return (
        <Typography variant="body2" color="textSecondary" align="center" style={{
            color: AppColors.GREY_TEXT
        }}>
            {'Copyright © '}
            <Link color="inherit" href={logInState === LoginState.STARTED ? "#" : "/"}>
                {Strings.APP_NAME}
            </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    );
}

export default function Footer() {
    return (
        <div style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            marginTop: 40,
            alignItems: 'center',
            padding: 20,
            backgroundColor: `${AppColors.PRIMARY_COLOR}`
        }}>
            <Copyright/>
        </div>
    );
}